import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { CTAButton } from './CTAButton';
import { CheckCircle2, Lock, ShieldCheck, Smartphone, Monitor, Tablet } from 'lucide-react';
const PURCHASE_LINK = 'https://fegion.shop/cart/46152988197003:1';
export function SalesPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '904978025482552');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-green-200" data-id="element-7">
      <CountdownTimer data-id="element-8" />
      <SocialProofPopup data-id="element-9" />

      {/* SECTION 1 - HERO */}
      <section className="pt-12 pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-10">
        <div className="inline-block bg-green-100 border border-green-200 rounded-full px-6 py-2 mb-8" data-id="element-11">
          <p className="text-green-800 font-semibold text-sm md:text-base" data-id="element-12">
            🌿 Para quienes buscan recuperar la sabiduría natural que nuestros
            abuelos usaban para curar dolores, inflamaciones y problemas de la
            piel.
          </p>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 tracking-tight mb-4 uppercase text-center" data-id="element-13">
          <span className="block" data-id="element-14">🌿 LAS 50 POMADAS</span>
          <span className="block text-green-700" data-id="element-15">MEDICINALES</span>
        </h1>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-600 mb-8" data-id="element-16">
          Que Usaban Antes de las Farmacias
        </h2>

        <a href="#compra" className="block cursor-pointer hover:opacity-95 transition-opacity mb-10" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/tMjNgYRWMvN3c1djnvvWH3/ChatGPT_Image_9_mar_2026,_00_26_02.png" alt="Las 50 Pomadas Medicinales" className="w-full max-w-3xl mx-auto rounded-xl shadow-2xl" data-id="element-18" />
        </a>

        <div className="max-w-3xl mx-auto text-lg md:text-xl text-gray-700 space-y-4 mb-8 font-medium" data-id="element-19">
          <p data-id="element-20">
            Durante generaciones, antes de que existieran las farmacias
            modernas, las personas confiaban en el poder de la naturaleza.
          </p>
          <p className="font-semibold text-gray-800" data-id="element-21">No tenían pastillas.</p>
          <p className="font-semibold text-gray-800" data-id="element-22">
            No tenían medicamentos industriales.
          </p>
          <p className="font-bold text-green-700 text-xl md:text-2xl mt-6" data-id="element-23">
            Pero sí tenían algo muy poderoso…
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-8 font-bold text-green-700 text-lg" data-id="element-24">
          <span data-id="element-25">🌿 Plantas medicinales</span>
          <span data-id="element-26">🌿 Aceites naturales</span>
          <span data-id="element-27">🌿 Remedios tradicionales</span>
        </div>

        <div className="max-w-3xl mx-auto text-lg md:text-xl text-gray-700 mb-8 font-medium" data-id="element-28">
          <p className="mb-6" data-id="element-29">
            Con esos simples ingredientes preparaban pomadas curativas que
            ayudaban a aliviar:
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-left max-w-2xl mx-auto" data-id="element-30">
            <span className="flex items-center gap-2" data-id="element-31">
              <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-32" />{' '}
              Dolores musculares
            </span>
            <span className="flex items-center gap-2" data-id="element-33">
              <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-34" />{' '}
              Inflamaciones
            </span>
            <span className="flex items-center gap-2" data-id="element-35">
              <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-36" />{' '}
              Golpes
            </span>
            <span className="flex items-center gap-2" data-id="element-37">
              <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-38" />{' '}
              Irritaciones de la piel
            </span>
            <span className="flex items-center gap-2" data-id="element-39">
              <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-40" />{' '}
              Picaduras
            </span>
            <span className="flex items-center gap-2" data-id="element-41">
              <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-42" />{' '}
              Resfriados
            </span>
          </div>
        </div>

        <CTAButton text="👉 SÍ, QUIERO RECUPERAR ESTE CONOCIMIENTO AHORA" data-id="element-43" />

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mt-6 font-semibold text-gray-700" data-id="element-44">
          <span className="flex items-center gap-2" data-id="element-45">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-46" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-2" data-id="element-47">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-48" /> Formato digital
          </span>
          <span className="flex items-center gap-2" data-id="element-49">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-50" /> Recetas paso a
            paso
          </span>
        </div>
      </section>

      {/* SECTION 2 - THE LOST KNOWLEDGE */}
      <section className="bg-gray-50 py-16 px-4 border-y border-gray-200" data-id="element-51">
        <div className="max-w-4xl mx-auto" data-id="element-52">
          <h3 className="text-3xl md:text-4xl font-black text-center mb-10" data-id="element-53">
            📘 Hoy Puedes Recuperar Ese Conocimiento Perdido
          </h3>

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 mb-8" data-id="element-54">
            <p className="text-lg md:text-xl text-gray-700 font-medium mb-6" data-id="element-55">
              Hemos recopilado ese saber tradicional en una guía práctica
              llamada:
            </p>
            <h4 className="text-2xl md:text-3xl font-black text-green-700 text-center mb-6" data-id="element-56">
              Las 50 Pomadas Medicinales Que Usaban Antes de las Farmacias
            </h4>
            <p className="text-lg text-gray-700 font-medium mb-6 text-center" data-id="element-57">
              Un libro digital fácil de seguir donde aprenderás cómo preparar
              pomadas naturales en casa usando plantas medicinales.
            </p>

            <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-xl font-bold text-green-700" data-id="element-58">
              <span data-id="element-59">✓ Sin químicos</span>
              <span data-id="element-60">✓ Sin complicaciones</span>
              <span data-id="element-61">✓ Solo ingredientes naturales</span>
            </div>
          </div>

          <p className="text-center text-xl md:text-2xl font-bold text-green-700" data-id="element-62">
            Y muchas de esas recetas han sobrevivido durante siglos.
          </p>
        </div>
      </section>

      {/* SECTION 3 - WHAT YOU'LL DISCOVER */}
      <section className="bg-[#1a2e1a] text-white py-20 px-4" data-id="element-63">
        <div className="max-w-4xl mx-auto text-center" data-id="element-64">
          <h2 className="text-4xl md:text-5xl font-black mb-12 text-green-400" data-id="element-65">
            🌱 Dentro del Libro Descubrirás
          </h2>

          <ul className="text-lg md:text-xl space-y-4 text-left max-w-2xl mx-auto bg-[#243524] p-8 rounded-xl border border-green-900" data-id="element-66">
            <li className="flex items-center gap-3" data-id="element-67">
              <div className="w-2 h-2 bg-green-400 rounded-full flex-shrink-0" data-id="element-68"></div>{' '}
              Cómo preparar pomadas medicinales paso a paso
            </li>
            <li className="flex items-center gap-3" data-id="element-69">
              <div className="w-2 h-2 bg-green-400 rounded-full flex-shrink-0" data-id="element-70"></div>{' '}
              Qué plantas usar para cada problema
            </li>
            <li className="flex items-center gap-3" data-id="element-71">
              <div className="w-2 h-2 bg-green-400 rounded-full flex-shrink-0" data-id="element-72"></div>{' '}
              Cómo combinar aceites naturales
            </li>
            <li className="flex items-center gap-3" data-id="element-73">
              <div className="w-2 h-2 bg-green-400 rounded-full flex-shrink-0" data-id="element-74"></div>{' '}
              Cómo conservar tus preparaciones
            </li>
            <li className="flex items-center gap-3" data-id="element-75">
              <div className="w-2 h-2 bg-green-400 rounded-full flex-shrink-0" data-id="element-76"></div>{' '}
              Cómo aprovechar propiedades curativas de las plantas
            </li>
          </ul>

          <blockquote className="text-2xl md:text-3xl text-green-300 italic mt-10 font-semibold" data-id="element-77">
            "Todo explicado de forma simple para que cualquier persona pueda
            hacerlo en casa."
          </blockquote>
        </div>
      </section>

      {/* SECTION 4 - SPECIFIC POMADAS */}
      <section className="py-20 px-4 bg-white" data-id="element-78">
        <div className="max-w-5xl mx-auto text-center" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-black mb-12" data-id="element-80">
            Algunas Pomadas Que Aprenderás a Preparar
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-81">
            <div className="bg-green-50 p-6 rounded-xl border border-green-200" data-id="element-82">
              <p className="text-lg font-bold text-green-800" data-id="element-83">
                🌿 Pomada de Árnica
              </p>
              <p className="text-gray-600" data-id="element-84">para golpes y hematomas</p>
            </div>
            <div className="bg-green-50 p-6 rounded-xl border border-green-200" data-id="element-85">
              <p className="text-lg font-bold text-green-800" data-id="element-86">
                🌿 Pomada de Caléndula
              </p>
              <p className="text-gray-600" data-id="element-87">para la piel</p>
            </div>
            <div className="bg-green-50 p-6 rounded-xl border border-green-200" data-id="element-88">
              <p className="text-lg font-bold text-green-800" data-id="element-89">
                🌿 Pomada de Romero
              </p>
              <p className="text-gray-600" data-id="element-90">para dolores musculares</p>
            </div>
            <div className="bg-green-50 p-6 rounded-xl border border-green-200" data-id="element-91">
              <p className="text-lg font-bold text-green-800" data-id="element-92">
                🌿 Pomada de Lavanda
              </p>
              <p className="text-gray-600" data-id="element-93">para picaduras</p>
            </div>
            <div className="bg-green-50 p-6 rounded-xl border border-green-200" data-id="element-94">
              <p className="text-lg font-bold text-green-800" data-id="element-95">
                🌿 Pomada de Eucalipto
              </p>
              <p className="text-gray-600" data-id="element-96">para congestión</p>
            </div>
            <div className="bg-green-50 p-6 rounded-xl border border-green-200" data-id="element-97">
              <p className="text-lg font-bold text-green-800" data-id="element-98">
                🌿 Pomada de Sábila
              </p>
              <p className="text-gray-600" data-id="element-99">para quemaduras</p>
            </div>
            <div className="bg-green-50 p-6 rounded-xl border border-green-200 md:col-start-2" data-id="element-100">
              <p className="text-lg font-bold text-green-800" data-id="element-101">
                🌿 Pomada de Consuelda
              </p>
              <p className="text-gray-600" data-id="element-102">para articulaciones</p>
            </div>
          </div>

          <p className="text-2xl font-bold text-green-700 mb-10" data-id="element-103">
            Y muchas más… hasta completar 50 recetas naturales.
          </p>

          <CTAButton text="🌿 QUIERO APRENDER LAS 50 RECETAS AHORA" data-id="element-104" />
        </div>
      </section>

      {/* SECTION 5 - BONUSES */}
      <section className="py-20 px-4 bg-[#1a2e1a] text-white" data-id="element-105">
        <div className="max-w-5xl mx-auto" data-id="element-106">
          <div className="text-center mb-12" data-id="element-107">
            <h2 className="text-4xl md:text-5xl font-black mb-4 text-green-400" data-id="element-108">
              🎁 Pero Eso No Es Todo… Bonos Especiales GRATIS
            </h2>

            <div className="inline-block bg-red-600 text-white font-black px-6 py-2 rounded-lg text-xl animate-pulse" data-id="element-109">
              Estos bonos son GRATIS por el día de hoy
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-110">
            {/* Bono 1 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col" data-id="element-111">
              <a href="#compra" className="block overflow-hidden bg-gray-100" data-id="element-112">
                <img src="https://cdn.magicpatterns.com/uploads/4gaUUyuxDSMWH8dinV5SJb/ChatGPT_Image_8_mar_2026,_23_43_03.png" alt="100 Plantas Medicinales y Sus Beneficios" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-113" />
              </a>
              <div className="p-6 flex-1 flex flex-col" data-id="element-114">
                <h4 className="text-xl font-black text-green-700 mb-4" data-id="element-115">
                  🎁 BONO #1 – 100 Plantas Medicinales y Sus Beneficios
                </h4>
                <p className="text-gray-600 mb-4" data-id="element-116">
                  Una guía práctica donde descubrirás 100 plantas medicinales y
                  sus propiedades.
                </p>
                <ul className="space-y-3 font-medium flex-1" data-id="element-117">
                  <li className="flex items-start gap-2" data-id="element-118">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-119" />{' '}
                    Descubre 100 plantas medicinales
                  </li>
                  <li className="flex items-start gap-2" data-id="element-120">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-121" />{' '}
                    Propiedades de cada planta
                  </li>
                  <li className="flex items-start gap-2" data-id="element-122">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-123" />{' '}
                    Cómo utilizarlas correctamente
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col" data-id="element-124">
              <a href="#compra" className="block overflow-hidden bg-gray-100" data-id="element-125">
                <img src="https://cdn.magicpatterns.com/uploads/oZMDpok9SdzbziXJW8mBes/ChatGPT_Image_8_mar_2026,_23_42_46.png" alt="Guía de Aceites Medicinales Naturales" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-126" />
              </a>
              <div className="p-6 flex-1 flex flex-col" data-id="element-127">
                <h4 className="text-xl font-black text-green-700 mb-4" data-id="element-128">
                  🎁 BONO #2 – Guía de Aceites Medicinales Naturales
                </h4>
                <p className="text-gray-600 mb-4" data-id="element-129">
                  Los aceites son la base de muchas pomadas. En esta guía
                  aprenderás todo sobre ellos.
                </p>
                <ul className="space-y-3 font-medium flex-1" data-id="element-130">
                  <li className="flex items-start gap-2" data-id="element-131">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-132" />{' '}
                    Qué aceites utilizar
                  </li>
                  <li className="flex items-start gap-2" data-id="element-133">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-134" />{' '}
                    Propiedades de cada aceite
                  </li>
                  <li className="flex items-start gap-2" data-id="element-135">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-136" />{' '}
                    Cómo preparar aceites medicinales
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 - WHAT YOU'LL RECEIVE */}
      <section className="py-16 px-4 bg-white" data-id="element-137">
        <div className="max-w-4xl mx-auto text-center" data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-black mb-10" data-id="element-139">
            📦 En Total Recibirás
          </h2>

          <div className="space-y-4 max-w-xl mx-auto mb-8" data-id="element-140">
            <div className="flex items-center gap-4 bg-green-50 p-4 rounded-xl border border-green-200" data-id="element-141">
              <CheckCircle2 className="text-green-600 w-8 h-8 flex-shrink-0" data-id="element-142" />
              <p className="text-lg font-bold text-left" data-id="element-143">
                Libro principal: Las 50 Pomadas Medicinales
              </p>
            </div>
            <div className="flex items-center gap-4 bg-green-50 p-4 rounded-xl border border-green-200" data-id="element-144">
              <CheckCircle2 className="text-green-600 w-8 h-8 flex-shrink-0" data-id="element-145" />
              <p className="text-lg font-bold text-left" data-id="element-146">
                Bono 1: 100 Plantas Medicinales
              </p>
            </div>
            <div className="flex items-center gap-4 bg-green-50 p-4 rounded-xl border border-green-200" data-id="element-147">
              <CheckCircle2 className="text-green-600 w-8 h-8 flex-shrink-0" data-id="element-148" />
              <p className="text-lg font-bold text-left" data-id="element-149">
                Bono 2: Guía de Aceites Medicinales
              </p>
            </div>
          </div>

          <p className="text-xl font-semibold text-gray-600" data-id="element-150">
            Todo en formato digital listo para descargar.
          </p>
        </div>
      </section>

      {/* SECTION 7 - WHO IS THIS FOR */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-151">
        <div className="max-w-4xl mx-auto" data-id="element-152">
          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-green-600" data-id="element-153">
            <h3 className="text-2xl font-black mb-6 text-gray-900" data-id="element-154">
              💚 ¿Para Quién Es Este Libro?
            </h3>
            <p className="text-lg text-gray-600 mb-6" data-id="element-155">
              Este libro es ideal si:
            </p>
            <ul className="space-y-4 font-medium text-lg" data-id="element-156">
              <li className="flex items-start gap-3" data-id="element-157">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-158" />{' '}
                Te interesa la medicina natural
              </li>
              <li className="flex items-start gap-3" data-id="element-159">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-160" />{' '}
                Quieres aprender remedios tradicionales
              </li>
              <li className="flex items-start gap-3" data-id="element-161">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-162" />{' '}
                Te gustan las plantas medicinales
              </li>
              <li className="flex items-start gap-3" data-id="element-163">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-164" />{' '}
                Buscas alternativas naturales para el cuidado de la piel
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* SECTION 8 - IMAGINE */}
      <section className="py-20 px-4 bg-white" data-id="element-165">
        <div className="max-w-4xl mx-auto text-center" data-id="element-166">
          <h2 className="text-4xl md:text-5xl font-black mb-12" data-id="element-167">
            ⚡ Imagina Poder…
          </h2>

          <div className="space-y-6 text-2xl md:text-3xl font-bold text-green-700" data-id="element-168">
            <p data-id="element-169">🌿 Preparar tus propias pomadas naturales</p>
            <p data-id="element-170">
              🌿 Conocer plantas medicinales que muchas personas han olvidado
            </p>
            <p data-id="element-171">
              🌿 Recuperar conocimientos que se usaban antes de las farmacias
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 9 - TESTIMONIALS */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-172">
        <div className="max-w-6xl mx-auto" data-id="element-173">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-174">
            Lo que dicen quienes ya tienen el libro...
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-175">
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-176">
              <div className="flex items-center gap-4 mb-4" data-id="element-177">
                <img src="https://i.pravatar.cc/80?img=5" alt="Carmen López" className="w-14 h-14 rounded-full" data-id="element-178" />
                <div data-id="element-179">
                  <h4 className="font-bold text-gray-900" data-id="element-180">Carmen López</h4>
                  <p className="text-sm text-gray-500" data-id="element-181">Ama de casa - México</p>
                </div>
              </div>
              <div className="flex text-green-500 mb-2" data-id="element-182">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-183">
                "Preparé la pomada de árnica y me ayudó muchísimo con un golpe
                que se dio mi hijo. Nunca pensé que fuera tan fácil de hacer."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-184">
              <div className="flex items-center gap-4 mb-4" data-id="element-185">
                <img src="https://i.pravatar.cc/80?img=11" alt="Rosa Martínez" className="w-14 h-14 rounded-full" data-id="element-186" />
                <div data-id="element-187">
                  <h4 className="font-bold text-gray-900" data-id="element-188">Rosa Martínez</h4>
                  <p className="text-sm text-gray-500" data-id="element-189">
                    Terapeuta natural - Colombia
                  </p>
                </div>
              </div>
              <div className="flex text-green-500 mb-2" data-id="element-190">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-191">
                "Las recetas son fáciles de seguir. Ya hice 5 pomadas diferentes
                y mis clientes están encantados con los resultados."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-192">
              <div className="flex items-center gap-4 mb-4" data-id="element-193">
                <img src="https://i.pravatar.cc/80?img=9" alt="Elena García" className="w-14 h-14 rounded-full" data-id="element-194" />
                <div data-id="element-195">
                  <h4 className="font-bold text-gray-900" data-id="element-196">Elena García</h4>
                  <p className="text-sm text-gray-500" data-id="element-197">Herbolaria - Perú</p>
                </div>
              </div>
              <div className="flex text-green-500 mb-2" data-id="element-198">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-199">
                "Mi abuela usaba remedios así. Qué alegría recuperar ese
                conocimiento y poder transmitirlo a mis hijas."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 lg:col-start-1 lg:col-end-2 lg:ml-auto lg:w-full" data-id="element-200">
              <div className="flex items-center gap-4 mb-4" data-id="element-201">
                <img src="https://i.pravatar.cc/80?img=12" alt="Patricia Sánchez" className="w-14 h-14 rounded-full" data-id="element-202" />
                <div data-id="element-203">
                  <h4 className="font-bold text-gray-900" data-id="element-204">Patricia Sánchez</h4>
                  <p className="text-sm text-gray-500" data-id="element-205">
                    Madre de familia - Argentina
                  </p>
                </div>
              </div>
              <div className="flex text-green-500 mb-2" data-id="element-206">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-207">
                "La guía de aceites es increíble. Ahora entiendo qué aceite usar
                para cada cosa. Muy completo todo."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 lg:col-start-2 lg:col-end-3" data-id="element-208">
              <div className="flex items-center gap-4 mb-4" data-id="element-209">
                <img src="https://i.pravatar.cc/80?img=1" alt="Lucía Fernández" className="w-14 h-14 rounded-full" data-id="element-210" />
                <div data-id="element-211">
                  <h4 className="font-bold text-gray-900" data-id="element-212">Lucía Fernández</h4>
                  <p className="text-sm text-gray-500" data-id="element-213">Emprendedora - Chile</p>
                </div>
              </div>
              <div className="flex text-green-500 mb-2" data-id="element-214">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-215">
                "Nunca pensé que preparar pomadas fuera tan sencillo. El libro
                lo explica todo paso a paso. ¡Muy recomendado!"
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 10 - PURCHASE SECTION */}
      <section id="compra" className="py-20 px-4 bg-white border-t border-gray-200" data-id="element-216">
        <div className="max-w-4xl mx-auto bg-green-50 rounded-3xl p-8 md:p-12 border-4 border-green-600 shadow-2xl relative" data-id="element-217">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-2 rounded-full font-black text-lg md:text-xl shadow-lg whitespace-nowrap" data-id="element-218">
            ⏰ Oferta disponible por tiempo limitado
          </div>

          <div className="mt-8 mb-10" data-id="element-219">
            <h3 className="text-2xl md:text-3xl font-black text-center mb-8 text-gray-900" data-id="element-220">
              Valor del Paquete Completo
            </h3>
            <div className="space-y-4 max-w-xl mx-auto" data-id="element-221">
              <div className="flex justify-between items-center py-3 border-b border-green-200" data-id="element-222">
                <p className="font-bold text-gray-900 text-lg" data-id="element-223">
                  Libro: Las 50 Pomadas Medicinales
                </p>
                <p className="font-black text-gray-700 text-lg" data-id="element-224">$15.000</p>
              </div>
              <div className="flex justify-between items-center py-3 border-b border-green-200" data-id="element-225">
                <p className="font-bold text-gray-900 text-lg" data-id="element-226">
                  Bono 1: 100 Plantas Medicinales
                </p>
                <p className="font-black text-gray-700 text-lg" data-id="element-227">$10.000</p>
              </div>
              <div className="flex justify-between items-center py-3 border-b border-green-200" data-id="element-228">
                <p className="font-bold text-gray-900 text-lg" data-id="element-229">
                  Bono 2: Guía de Aceites Medicinales
                </p>
                <p className="font-black text-gray-700 text-lg" data-id="element-230">$8.000</p>
              </div>
              <div className="flex justify-between items-center pt-4 mt-2 border-t-2 border-gray-800" data-id="element-231">
                <p className="font-black text-gray-900 text-xl md:text-2xl" data-id="element-232">
                  Valor total:
                </p>
                <p className="font-black text-red-600 text-2xl md:text-3xl line-through" data-id="element-233">
                  $33.000
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mb-6" data-id="element-234">
            <p className="text-4xl md:text-5xl font-black text-green-600 mt-2" data-id="element-235">
              HOY SOLO: $9.990
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl border border-gray-200 mb-10 text-center" data-id="element-236">
            <div className="flex justify-center mb-4" data-id="element-237">
              <ShieldCheck className="w-16 h-16 text-green-500" data-id="element-238" />
            </div>
            <h4 className="text-2xl font-black mb-2 flex items-center justify-center gap-2" data-id="element-239">
              <Lock className="w-6 h-6" data-id="element-240" /> Garantía de Satisfacción
            </h4>
            <p className="text-gray-700 font-medium mb-4" data-id="element-241">
              Si el contenido no cumple tus expectativas, simplemente puedes
              solicitar un reembolso dentro del período de garantía.
            </p>
            <p className="text-gray-900 font-bold" data-id="element-242">Tu compra es 100% segura.</p>
          </div>

          <CTAButton text="👉 SÍ, QUIERO MI LIBRO + BONOS AHORA" href={PURCHASE_LINK} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-243" />
          <div className="text-center mt-4 text-sm text-gray-500 font-medium flex items-center justify-center gap-1" data-id="element-244">
            <Lock className="w-4 h-4" data-id="element-245" /> Pago 100% Seguro
          </div>
        </div>
      </section>

      {/* SECTION 11 - INSTANT ACCESS */}
      <section className="py-20 px-4 bg-[#1a2e1a] text-white text-center" data-id="element-246">
        <div className="max-w-4xl mx-auto" data-id="element-247">
          <h2 className="text-4xl md:text-5xl font-black mb-8 text-green-400" data-id="element-248">
            💻 Acceso Inmediato
          </h2>
          <p className="text-xl md:text-2xl mb-8" data-id="element-249">
            Una vez que completes tu compra recibirás acceso inmediato al libro
            digital para descargarlo y comenzar a usarlo hoy mismo.
          </p>

          <p className="text-lg mb-6" data-id="element-250">Podrás verlo desde:</p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 text-xl font-bold" data-id="element-251">
            <span className="flex items-center gap-2" data-id="element-252">
              <Smartphone className="w-8 h-8 text-green-400" data-id="element-253" /> Celular
            </span>
            <span className="flex items-center gap-2" data-id="element-254">
              <Monitor className="w-8 h-8 text-green-400" data-id="element-255" /> Computadora
            </span>
            <span className="flex items-center gap-2" data-id="element-256">
              <Tablet className="w-8 h-8 text-green-400" data-id="element-257" /> Tablet
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 12 - FINAL CTA */}
      <section className="py-24 px-4 bg-white text-center" data-id="element-258">
        <div className="max-w-4xl mx-auto" data-id="element-259">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 text-center" data-id="element-260">
            <span className="block" data-id="element-261">🌿 LAS 50 POMADAS</span>
            <span className="block text-green-700" data-id="element-262">MEDICINALES</span>
          </h2>
          <p className="text-2xl md:text-3xl font-bold text-gray-600 mb-8" data-id="element-263">
            Recupera el Poder de la Medicina Natural
          </p>
          <p className="text-xl text-gray-600 mb-12" data-id="element-264">
            Miles de personas están redescubriendo los beneficios de las plantas
            medicinales. Hoy tú también puedes aprender este conocimiento
            tradicional.
          </p>

          <CTAButton text="🌿 QUIERO ACCEDER AL LIBRO + BONOS AHORA" href={PURCHASE_LINK} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-265" />

          <p className="mt-6 text-lg font-semibold text-gray-500" data-id="element-266">
            Acceso inmediato al libro + bonos incluidos
          </p>
        </div>
      </section>
    </div>;
}